module.exports = __webpack_public_path__ + "static/media/bsv.709dc32e.svg";